import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";
import { defaultCompetitionsExportFieldNames } from "../constants/exportFields.ts";

export const useExportCompetitions = () => {
  const { sport = "", organizationId = "" } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) => {
      const body = {
        fieldNames: fieldNames || defaultCompetitionsExportFieldNames,
      };
      return await request(`${sport}/o/${organizationId}/competitions/export`, {
        method: "POST",
        body,
      });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        notification.success({
          message: formatMessage({ id: "competitions.export.started" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
